import React, { useState, useEffect } from "react";
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import $ from "jquery";
import { Container, Row, Col, Button } from 'react-bootstrap';
import "../StaticComponent/OurTeam/OurTeam.scss"
import TeamMenus from './PeopleListingHead';
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "@StarberryUtils";
import Select from 'react-select';
import ImageTransform from "../common/ggfx-client/module/components/image-transform";
import ImageModule from "../common/Image_Module";
import _ from "lodash"
import PlayVideo from "../Play/custom-video";
import './Peoples.scss';

const GET_ALL_TEAMS = gql`
query GETTEAMS{
  peoples(sort: "Sort:asc",where:{Publish:true}) {
    Name
    URL
    id
    Designation
    ggfx_results {
            id
            src_cftle
            src_url
            transforms
            updatedAt
            createdAt
            _id
    }
    Tile_Image {
      url
    }
    Video_URL
    Select_Category {
      Name
      URL
    }
    people_locations {
      URL
    }
    people_languages {
      URL
    }
    imagetransforms
  } 
}
`;


function TeamList() {

  const queryData = useStaticQuery(graphql`
      query {
        glstrapi {
          areaGuides(sort: "Sort:asc", where: {Publish: true}) {
            id
            Title
            URL 
          }
          peopleLanguages(sort: "Sort:asc", where: {Publish: true}) {
            Name
            URL
          }
          peopleLocations(sort: "Sort:asc", where: {Publish: true}) {
            Name
            URL
          }
        }
      }
    `);

  const peopleLocations = queryData.glstrapi.peopleLocations
  const peopleLanguages = queryData.glstrapi.peopleLanguages


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [teamid, setteamid] = useState(false);

  const handleShow = (event) => {
    setteamid(event);
    setShow(true);
  }
  var options = [{ value: null, label: 'All Location' }];
  _.forEach(peopleLocations, (area) => {
    options.push({ value: area.URL, label: area.Name })
  })

  var languages = [{ value: null, label: 'All Languages' }];
  _.forEach(peopleLanguages, (lang) => {
    languages.push({ value: lang.URL, label: lang.Name })
  })
  const [filteredTeam, setFilteredTeam] = useState([])
  const [allTeam, setAllTeam] = useState([])
  const [teamCategory, setTeamCategory] = useState("all")
  const [selectedOption, setSelectedOption] = useState({ value: null, label: 'All Location' })
  const [selectedLangOption, setSelectedLangOption] = useState({ value: null, label: 'All Languages' })
  const [isLess, setLess] = useState(false);
  const [loadMoreList, setLoadMoreList] = useState([]);
  const { loading, error, data } = useQuery(GET_ALL_TEAMS);
  var intialNumberOfReview = 8;
  var handleChange = selectedOption => {
    setSelectedOption(selectedOption);
  };
  var handleLangChange = selectedOption => {
    setSelectedLangOption(selectedOption);
  };
  var cat_array = [];
  if (!loading && _.isEmpty(allTeam)) {
    setAllTeam(data.peoples)
    setFilteredTeam(data.peoples)
    setLoadMoreList(data.peoples.slice(0, 8));
  }
  const handlerSelect = (selected) => {
    setTeamCategory(selected)
  }



  useEffect(() => {
    var teams = allTeam;
    if (teamCategory !== "all") {
      teams = teams.filter(team => {
        let category = _.includes(_.map(team.Select_Category, 'URL'), teamCategory)
        if (category) {
          return category
        }
      });
    }
    var teamLoc = teams;
    var teamLang = teams;
    if (selectedOption.value != null) {
      teams = teams.filter(team => {
        let category = _.includes(_.map(team.people_locations, 'URL'), selectedOption.value)
        if (category) {
          return category
        }
      });
    }
    if (selectedLangOption.value != null) {
      teams = teams.filter(team => {
        let category = _.includes(_.map(team.people_languages, 'URL'), selectedLangOption.value)
        if (category) {
          return category
        }
      });
    }

    // teams = _.uniqBy(_.merge(teamLoc, teamLang), function (e) {
    //   return e.id;
    // }); 
    setFilteredTeam(teams)
    setLess(false);
    setLoadMoreList(teams.slice(0, 10));

  }, [teamCategory, selectedOption, selectedLangOption])

  const loadMore = () => {
    let primeryLength = loadMoreList.length;
    let newList = filteredTeam.slice(
      0,
      primeryLength + intialNumberOfReview
    );
    setLoadMoreList(newList);
    if (newList.length === filteredTeam.length) {
      setLess(true);
    } else {
      setLess(false);
    }
  };
// const ImageSrc = {
//      url:   node?.Full_Image.url
//     }
  const ImageRender = ({ image_url, node, processedImages }) => {
    return (
      // <ImageTransform 
      //   imagesources={image_url} 
      //   renderer="srcSet" 
      //   imagename="peoples.Tile_Image.tile" 
      //   attr={{ alt: node.Name + ' - Dacha', class: '' }} 
      //   imagetransformresult={processedImages} 
      //   id={node.id} 
      // />

      <ImageModule 
          ImageSrc={node?.Tile_Image} 
          attr={{ alt: node?.Name  + ' - Dacha' || "" }} 
          ggfx_results={node?.ggfx_results} 
          imagename="peoples.Tile_Image.tile" 
          strapi_id={node?.id} 
      />
    )
  }


  if (loading) return (
    <div className="static-details gql-loading-screen">
      <Container className="pad-50">
        <div className="gql-loading">Loading ...</div>
      </Container>
    </div>);
  return (
    <>
      <div className="people-listing-page our-team">
        <Container>
          <div class="team-header">
            <TeamMenus handlerSelect={handlerSelect} />
          <div class="team-filter">
            <Row>
              <Col lg={3} md={6} className="team-location-select pr-md-0">
                <Select
                  name="people-location"
                  value={selectedOption}
                  onChange={handleChange}
                  options={options}
                  defaultMenuIsOpen={false}
                  className={`select-form-control location-filter text-xs`}
                  classNamePrefix={`select-team-option`}
                  isSearchable={false}
                />
              </Col>
              <Col lg={3} md={6} className="team-language-select px-md-0">
                <Select
                  name="people-language"
                  value={selectedLangOption}
                  onChange={handleLangChange}
                  options={languages}
                  defaultMenuIsOpen={false}
                  className={`select-form-control text-xs`}
                  classNamePrefix={`select-team-option`}
                  isSearchable={false}
                />
              </Col>
            </Row>
          </div>
          </div>
          <div className="people-list-wrapper row sec-pdb-120">
            {filteredTeam && filteredTeam.length > 0 ?
              <>
                {filteredTeam.map((node, key) => {
                  cat_array = []
                  {
                    node.Select_Category && node.Select_Category.map((catname) => {
                      cat_array.push(catname.URL)
                    })
                  }


                  const image_url = node.Tile_Image.url

                  let processedImages = JSON.stringify({});
                  if (node?.imagetransforms?.Tile_Image_Transforms) {
                    processedImages = node.imagetransforms.Tile_Image_Transforms;
                  }

                  return <>

                    <div className={`about-team-list peoples-list  col-sm-6 col-lg-4 col-xl-3 ${cat_array.join(' ')}`}>
                      <div className="team-wrapper">
                        {node.Tile_Image &&
                            <div className="team-member-img-wrap img-zoom">
                             <Link to={node.URL}>
                              <ImageRender processedImages={processedImages} image_url={image_url} node={node} />
                              </Link>
                            </div>
                        }
                        {node.Video_URL &&
                          <div className="banner-btn people-video-btn">
                            <PlayVideo url={node.Video_URL} />
                          </div>
                        }
                        <div className="team-info">
                          <div className="member-name text-md-bold">{node.Name}</div>
                          <div className="member-designation text-xxs">{node.Designation}</div>
                        </div>

                      </div>
                    </div>
                  </>
                })}
              </>
              : <div className="team-wrapper col-12"><h3>No Result</h3></div>}



          </div>
          {/* <div className="d-flex justify-content-center load-more-btn learn-more">
            {filteredTeam && filteredTeam.length > 10 && !isLess ? (
              <Button variant="outline" className="btn btn-secondary " onClick={loadMore}>
                Load More
              </Button>
            ) : null}
          </div> */}
        </Container>
      </div>
    </>
  )

}
export default TeamList
